import { LocaleClub } from '../en/club'

const club: LocaleClub = {
  clubs: 'Câu Lạc Bộ',
  myClubs: 'Câu Lạc Bộ Của Tôi',
  exploreClubs: 'Khám Phá Câu Lạc Bộ',
  requested: 'Đã yêu cầu:',
  invited: 'Được mời:',
  joinClub: 'Tham Gia Câu Lạc Bộ',
  leaveClub: 'Rời Câu Lạc Bộ',
  requestPending: 'Yêu Cầu Đang Chờ Xử Lý',
  invitation: 'Lời Mời',
  invitationDesc: 'Bạn đang được mời bởi giám đốc câu lạc bộ, bạn có muốn tham gia câu lạc bộ này không?',
  acceptInvitation: 'Bạn đã trở thành thành viên của câu lạc bộ được mời.',
  declineInvitation: 'Bạn đã từ chối trở thành thành viên của câu lạc bộ được mời.',
  editClub: 'Chỉnh Sửa Câu Lạc Bộ',
  fixClubPayments: 'Khắc phục sự cố tài khoản thanh toán của câu lạc bộ.',
  setUpYourClubPayments: 'Thiết lập thanh toán câu lạc bộ của bạn để tạo sự kiện.',
  about: 'Giới Thiệu',
  clubDetails: 'Chi Tiết Câu Lạc Bộ',
  clubContact: 'Liên Hệ Câu Lạc Bộ',
  clubAbout: 'Giới Thiệu Về Câu Lạc Bộ',
  directors: 'Giám Đốc',
  organizers: 'Người Tổ Chức',
  invitePlayers: 'Mời Người Chơi',
  importPlayersCSV: 'Nhập Người Chơi Qua CSV',
  removeMember: 'Xóa Thành Viên',
  removeMemberDesc: 'Thành viên này sẽ bị xóa khỏi câu lạc bộ',
  playerAddedSuccess: 'Thêm Người Chơi Thành Công',
  importPlayers: 'Nhập Người Chơi',
  importMatchesCSV: 'Nhập Trận Đấu Qua CSV',
  importMatches: 'Nhập Trận Đấu',
  createNewEvent: 'Tạo Sự Kiện Mới',
  eventDetails: 'Chi Tiết Sự Kiện',
  addOrganizers: 'Thêm Người Tổ Chức',
  clubOrganizers: 'Người tổ chức câu lạc bộ phải có tài khoản DUPR để được thêm vào câu lạc bộ của bạn.',
  clubPlayers: 'Người chơi câu lạc bộ phải có tài khoản DUPR để được thêm vào câu lạc bộ của bạn.',
  addOrganizer: 'Thêm Người Tổ Chức',
  addMember: 'Thêm Thành Viên',
  inviteAPLayer: 'Mời Một Người Chơi',
  inviteAPLayerDesc:
    'Sau khi bạn mời, người chơi được mời phải đăng ký (tạo tài khoản) bằng email đã nhập dưới đây để xem kết quả của họ.',
  clubName: 'Tên Câu Lạc Bộ',
  createEventDesc:
    'Gieo hạt và đăng ký hiện không khả dụng vì chúng tôi đang làm việc để kết nối bạn với các đối tác API của chúng tôi.',
  seedMatchesDesc:
    'Gieo hạt không còn khả dụng nữa. Chúng tôi muốn quảng bá các đối tác API Quản Lý Sự Kiện của mình, trên nút [Đăng Ký] bạn có thể dán URL sự kiện của mình từ các phần mềm khác.',
  leaveDUPRWarning: 'Bạn sẽ được chuyển hướng đến trang đăng ký và rời khỏi trang DUPR này khi nhấn vào nút này.',
  clubsNearMe: 'Câu Lạc Bộ Gần Tôi',
  removeOrganizerTitle: 'Xóa Người Tổ Chức Câu Lạc Bộ',
  removeOrganizerText: 'Bạn có chắc chắn muốn xóa tài khoản này khỏi vai trò người tổ chức không?',
  removeOrganizer: 'Xác nhận',
  clubPosts: 'Bài viết',
}

export default club
